import { useEffect, useState } from 'react';

import { TextArea } from '@revenuemarket/cds';

interface TextAreaProps {
  description?: string;
  isLoading?: boolean;
  onSave: (descriptionInput: string) => void;
}
export const DESCRIPTION_MAX_LENGTH_INFO = '100자 까지만 입력할 수 있어요.';
export const DESCRIPTION_MAX_LENGTH = 100;

const DescriptionTextArea: React.FC<TextAreaProps> = ({ description, isLoading, onSave }) => {
  const [descriptionInput, setDescriptionInput] = useState<string>(description ?? '');

  const onTextSave = async () => {
    // 변경되지않았으면 저장 안함
    if (descriptionInput === description) {
      return;
    }
    if (descriptionInput.length > DESCRIPTION_MAX_LENGTH) {
      setDescriptionInput(description ?? '');
      return;
    }
    onSave(descriptionInput);
  };

  const getAdditionalText = () => {
    if (descriptionInput?.length > DESCRIPTION_MAX_LENGTH) {
      return '100자 까지만 입력할 수 있어요.';
    }
  };

  useEffect(() => {
    if (description) {
      setDescriptionInput(description);
    }
  }, [description]);

  return (
    <TextArea
      style={{ width: '100%' }}
      value={descriptionInput}
      onChange={(e) => setDescriptionInput(e.target.value)}
      onBlur={() => onTextSave()}
      disabled={isLoading}
      additionalText={getAdditionalText()}
    />
  );
};

export default DescriptionTextArea;
